import { Sport } from '../../redux/slices/sportsSlice'

export const sports: Sport[] = [
	{
		sport_id: 'soccer',
		name: 'Soccer',
		pt_name: 'Futebol',
		sport_icon: '/sports/icons/soccer.svg',
		leagues: [
			{
				league_name: 'EURO 2024',
				pt_name: 'EURO 2024',
				games: [
					{
						id: 11,
						start_time: '18:00',
						home: { name: 'Croatia', pt_name: 'Croácia', odds: 2.5 },
						away: { name: 'England', pt_name: 'Inglaterra', odds: 2.8 },
						draw: 3.0,
					},
					{
						id: 12,
						start_time: '18:00',
						home: { name: 'France', pt_name: 'França', odds: 2.2 },
						away: { name: 'Germany', pt_name: 'Alemanha', odds: 3.0 },
						draw: 3.5,
					},
					{
						id: 13,
						start_time: '18:00',
						home: { name: 'Spain', pt_name: 'Espanha', odds: 7.8 },
						away: { name: 'Italy', pt_name: 'Itália', odds: 12.5 },
						draw: 3.0,
					},
				],
			},
			{
				league_name: 'UEFA Champions League',
				pt_name: 'Liga dos Campeões da UEFA',
				games: [
					{
						id: 14,
						start_time: '18:00',
						home: { name: 'Juventus', pt_name: 'Juventus', odds: 2.5 },
						away: { name: 'Liverpool', pt_name: 'Liverpool', odds: 2.8 },
						draw: 3.0,
					},
					{
						id: 15,
						start_time: '18:00',
						home: { name: 'Real Madrid', pt_name: 'Real Madrid', odds: 2.2 },
						away: { name: 'Manchester City', pt_name: 'Manchester City', odds: 3.0 },
						draw: 3.5,
					},
					{
						id: 16,
						start_time: '18:00',
						home: { name: 'Barcelona', pt_name: 'Barcelona', odds: 2.8 },
						away: { name: 'Bayern Munich', pt_name: 'Bayern Munich', odds: 2.5 },
						draw: 3.0,
					},
				],
			},
		],
	},
	{
		sport_id: 'tennis',
		name: 'Tennis',
		pt_name: 'Tênis',
		sport_icon: '/sports/icons/tennis.svg',
		leagues: [
			{
				league_name: 'Wimbledon',
				pt_name: 'Wimbledon',
				games: [
					{
						id: 21,
						start_time: '18:00',
						home: { name: 'Roger Federer', pt_name: 'Roger Federer', odds: 1.5 },
						away: { name: 'Rafael Nadal', pt_name: 'Rafael Nadal', odds: 2.5 },
					},
					{
						id: 22,
						start_time: '18:00',
						home: { name: 'Serena Williams', pt_name: 'Serena Williams', odds: 1.8 },
						away: { name: 'Maria Sharapova', pt_name: 'Maria Sharapova', odds: 2.2 },
					},
					{
						id: 23,
						start_time: '18:00',
						home: { name: 'Novak Djokovic', pt_name: 'Novak Djokovic', odds: 1.6 },
						away: { name: 'Andy Murray', pt_name: 'Andy Murray', odds: 2.4 },
					},
				],
			},
			{
				league_name: 'US Open',
				pt_name: 'US Open',
				games: [
					{
						id: 24,
						start_time: '18:00',
						home: { name: 'Roger Federer', pt_name: 'Roger Federer', odds: 1.5 },
						away: { name: 'Rafael Nadal', pt_name: 'Rafael Nadal', odds: 2.5 },
					},
					{
						id: 25,
						start_time: '18:00',
						home: { name: 'Serena Williams', pt_name: 'Serena Williams', odds: 1.8 },
						away: { name: 'Maria Sharapova', pt_name: 'Maria Sharapova', odds: 2.2 },
					},
					{
						id: 26,
						start_time: '18:00',
						home: { name: 'Novak Djokovic', pt_name: 'Novak Djokovic', odds: 1.6 },
						away: { name: 'Andy Murray', pt_name: 'Andy Murray', odds: 2.4 },
					},
				],
			},
		],
	},
	{
		sport_id: 'basketball',
		name: 'Basketball',
		pt_name: 'Basquete',
		sport_icon: '/sports/icons/basketball.svg',
		leagues: [
			{
				league_name: 'NBA',
				pt_name: 'NBA',
				games: [
					{
						id: 31,
						start_time: '18:00',
						home: { name: 'Los Angeles Lakers', pt_name: 'Los Angeles Lakers', odds: 1.7 },
						away: { name: 'Golden State Warriors', pt_name: 'Golden State Warriors', odds: 2.3 },
					},
					{
						id: 32,
						start_time: '18:00',
						home: { name: 'Boston Celtics', pt_name: 'Boston Celtics', odds: 1.5 },
						away: { name: 'Chicago Bulls', pt_name: 'Chicago Bulls', odds: 2.5 },
					},
					{
						id: 33,
						start_time: '18:00',
						home: { name: 'Miami Heat', pt_name: 'Miami Heat', odds: 1.8 },
						away: { name: 'New York Knicks', pt_name: 'New York Knicks', odds: 2.2 },
					},
				],
			},
			{
				league_name: 'NBA Playoffs',
				pt_name: 'Playoffs da NBA',
				games: [
					{
						id: 34,
						start_time: '18:00',
						home: { name: 'Los Angeles Lakers', pt_name: 'Los Angeles Lakers', odds: 1.7 },
						away: { name: 'Golden State Warriors', pt_name: 'Golden State Warriors', odds: 2.3 },
					},
					{
						id: 35,
						start_time: '18:00',
						home: { name: 'Boston Celtics', pt_name: 'Boston Celtics', odds: 1.5 },
						away: { name: 'Chicago Bulls', pt_name: 'Chicago Bulls', odds: 2.5 },
					},
					{
						id: 36,
						start_time: '18:00',
						home: { name: 'Miami Heat', pt_name: 'Miami Heat', odds: 1.8 },
						away: { name: 'New York Knicks', pt_name: 'New York Knicks', odds: 2.2 },
					},
				],
			},
		],
	},
	{
		sport_id: 'table-tennis',
		name: 'Table Tennis',
		pt_name: 'Tênis de Mesa',
		sport_icon: '/sports/icons/table-tennis.svg',
		leagues: [
			{
				league_name: 'Olympics',
				pt_name: 'Olimpíadas',
				games: [
					{
						id: 41,
						start_time: '18:00',
						home: { name: 'Ma Long', pt_name: 'Ma Long', odds: 1.6 },
						away: { name: 'Fan Zhendong', pt_name: 'Fan Zhendong', odds: 2.4 },
					},
					{
						id: 42,
						start_time: '18:00',
						home: { name: 'Ding Ning', pt_name: 'Ding Ning', odds: 1.8 },
						away: { name: 'Chen Meng', pt_name: 'Chen Meng', odds: 2.2 },
					},
					{
						id: 43,
						start_time: '18:00',
						home: { name: 'Tomokazu Harimoto', pt_name: 'Tomokazu Harimoto', odds: 1.7 },
						away: { name: 'Lin Yun-Ju', pt_name: 'Lin Yun-Ju', odds: 2.3 },
					},
				],
			},
			{
				league_name: 'World Championships',
				pt_name: 'Campeonato Mundial',
				games: [
					{
						id: 44,
						start_time: '18:00',
						home: { name: 'Ma Long', pt_name: 'Ma Long', odds: 1.6 },
						away: { name: 'Fan Zhendong', pt_name: 'Fan Zhendong', odds: 2.4 },
					},
					{
						id: 45,
						start_time: '18:00',
						home: { name: 'Ding Ning', pt_name: 'Ding Ning', odds: 1.8 },
						away: { name: 'Chen Meng', pt_name: 'Chen Meng', odds: 2.2 },
					},
					{
						id: 46,
						start_time: '18:00',
						home: { name: 'Tomokazu Harimoto', pt_name: 'Tomokazu Harimoto', odds: 1.7 },
						away: { name: 'Lin Yun-Ju', pt_name: 'Lin Yun-Ju', odds: 2.3 },
					},
				],
			},
		],
	},
	{
		sport_id: 'volleyball',
		name: 'Volleyball',
		pt_name: 'Voleibol',
		sport_icon: '/sports/icons/volleyball.svg',
		leagues: [
			{
				league_name: 'Olympics',
				pt_name: 'Olimpíadas',
				games: [
					{
						id: 51,
						start_time: '18:00',
						home: { name: 'Brazil', pt_name: 'Brasil', odds: 1.5 },
						away: { name: 'USA', pt_name: 'EUA', odds: 2.5 },
					},
					{
						id: 52,
						start_time: '18:00',
						home: { name: 'Italy', pt_name: 'Itália', odds: 1.7 },
						away: { name: 'Russia', pt_name: 'Rússia', odds: 2.3 },
					},
					{
						id: 53,
						start_time: '18:00',
						home: { name: 'China', pt_name: 'China', odds: 1.6 },
						away: { name: 'Japan', pt_name: 'Japão', odds: 2.4 },
					},
				],
			},
			{
				league_name: 'World Championships',
				pt_name: 'Campeonato Mundial',
				games: [
					{
						id: 54,
						start_time: '18:00',
						home: { name: 'Brazil', pt_name: 'Brasil', odds: 1.5 },
						away: { name: 'USA', pt_name: 'EUA', odds: 2.5 },
					},
					{
						id: 55,
						start_time: '18:00',
						home: { name: 'Italy', pt_name: 'Itália', odds: 1.7 },
						away: { name: 'Russia', pt_name: 'Rússia', odds: 2.3 },
					},
					{
						id: 56,
						start_time: '18:00',
						home: { name: 'China', pt_name: 'China', odds: 1.6 },
						away: { name: 'Japan', pt_name: 'Japão', odds: 2.4 },
					},
				],
			},
		],
	},
	{
		sport_id: 'american-football',
		name: 'American Football',
		pt_name: 'Futebol Americano',
		sport_icon: '/sports/icons/american-football.svg',
		leagues: [
			{
				league_name: 'NFL',
				pt_name: 'NFL',
				games: [
					{
						id: 61,
						start_time: '18:00',
						home: { name: 'Kansas City Chiefs', pt_name: 'Kansas City Chiefs', odds: 1.7 },
						away: { name: 'Buffalo Bills', pt_name: 'Buffalo Bills', odds: 2.3 },
					},
					{
						id: 62,
						start_time: '18:00',
						home: { name: 'New England Patriots', pt_name: 'New England Patriots', odds: 1.5 },
						away: { name: 'Miami Dolphins', pt_name: 'Miami Dolphins', odds: 2.5 },
					},
					{
						id: 63,
						start_time: '18:00',
						home: { name: 'Dallas Cowboys', pt_name: 'Dallas Cowboys', odds: 1.8 },
						away: { name: 'New York Giants', pt_name: 'New York Giants', odds: 2.2 },
					},
				],
			},
			{
				league_name: 'Super Bowl',
				pt_name: 'Super Bowl',
				games: [
					{
						id: 64,
						start_time: '18:00',
						home: { name: 'Kansas City Chiefs', pt_name: 'Kansas City Chiefs', odds: 1.7 },
						away: { name: 'Buffalo Bills', pt_name: 'Buffalo Bills', odds: 2.3 },
					},
					{
						id: 65,
						start_time: '18:00',
						home: { name: 'New England Patriots', pt_name: 'New England Patriots', odds: 1.5 },
						away: { name: 'Miami Dolphins', pt_name: 'Miami Dolphins', odds: 2.5 },
					},
					{
						id: 66,
						start_time: '18:00',
						home: { name: 'Dallas Cowboys', pt_name: 'Dallas Cowboys', odds: 1.8 },
						away: { name: 'New York Giants', pt_name: 'New York Giants', odds: 2.2 },
					},
				],
			},
		],
	},
	{
		sport_id: 'baseball',
		name: 'Baseball',
		pt_name: 'Beisebol',
		sport_icon: '/sports/icons/baseball.svg',
		leagues: [
			{
				league_name: 'MLB',
				pt_name: 'MLB',
				games: [
					{
						id: 71,
						start_time: '18:00',
						home: { name: 'New York Yankees', pt_name: 'New York Yankees', odds: 1.7 },
						away: { name: 'Boston Red Sox', pt_name: 'Boston Red Sox', odds: 2.3 },
					},
					{
						id: 72,
						start_time: '18:00',
						home: { name: 'Los Angeles Dodgers', pt_name: 'Los Angeles Dodgers', odds: 1.5 },
						away: { name: 'San Francisco Giants', pt_name: 'San Francisco Giants', odds: 2.5 },
					},
					{
						id: 73,
						start_time: '18:00',
						home: { name: 'Chicago Cubs', pt_name: 'Chicago Cubs', odds: 1.8 },
						away: { name: 'St. Louis Cardinals', pt_name: 'St. Louis Cardinals', odds: 2.2 },
					},
				],
			},
			{
				league_name: 'World Series',
				pt_name: 'Série Mundial',
				games: [
					{
						id: 74,
						start_time: '18:00',
						home: { name: 'New York Yankees', pt_name: 'New York Yankees', odds: 1.7 },
						away: { name: 'Boston Red Sox', pt_name: 'Boston Red Sox', odds: 2.3 },
					},
					{
						id: 75,
						start_time: '18:00',
						home: { name: 'Los Angeles Dodgers', pt_name: 'Los Angeles Dodgers', odds: 1.5 },
						away: { name: 'San Francisco Giants', pt_name: 'San Francisco Giants', odds: 2.5 },
					},
					{
						id: 76,
						start_time: '18:00',
						home: { name: 'Chicago Cubs', pt_name: 'Chicago Cubs', odds: 1.8 },
						away: { name: 'St. Louis Cardinals', pt_name: 'St. Louis Cardinals', odds: 2.2 },
					},
				],
			},
		],
	},
	{
		sport_id: 'bowling',
		name: 'Bowling',
		pt_name: 'Boliche',
		sport_icon: '/sports/icons/bowling.svg',
		leagues: [
			{
				league_name: 'PBA',
				pt_name: 'PBA',
				games: [
					{
						id: 81,
						start_time: '18:00',
						home: { name: 'Jason Belmonte', pt_name: 'Jason Belmonte', odds: 1.6 },
						away: { name: 'Pete Weber', pt_name: 'Pete Weber', odds: 2.4 },
					},
					{
						id: 82,
						start_time: '18:00',
						home: { name: 'Norm Duke', pt_name: 'Norm Duke', odds: 1.8 },
						away: { name: 'Chris Barnes', pt_name: 'Chris Barnes', odds: 2.2 },
					},
					{
						id: 83,
						start_time: '18:00',
						home: { name: 'Walter Ray Williams Jr.', pt_name: 'Walter Ray Williams Jr.', odds: 1.7 },
						away: { name: 'Parker Bohn III', pt_name: 'Parker Bohn III', odds: 2.3 },
					},
				],
			},
			{
				league_name: 'US Open',
				pt_name: 'US Open',
				games: [
					{
						id: 84,
						start_time: '18:00',
						home: { name: 'Jason Belmonte', pt_name: 'Jason Belmonte', odds: 1.6 },
						away: { name: 'Pete Weber', pt_name: 'Pete Weber', odds: 2.4 },
					},
					{
						id: 85,
						start_time: '18:00',
						home: { name: 'Norm Duke', pt_name: 'Norm Duke', odds: 1.8 },
						away: { name: 'Chris Barnes', pt_name: 'Chris Barnes', odds: 2.2 },
					},
					{
						id: 86,
						start_time: '18:00',
						home: { name: 'Walter Ray Williams Jr.', pt_name: 'Walter Ray Williams Jr.', odds: 1.7 },
						away: { name: 'Parker Bohn III', pt_name: 'Parker Bohn III', odds: 2.3 },
					},
				],
			},
		],
	},
	{
		sport_id: 'boxing',
		name: 'Boxing',
		pt_name: 'Boxe',
		sport_icon: '/sports/icons/boxing.svg',
		leagues: [
			{
				league_name: 'WBC',
				pt_name: 'WBC',
				games: [
					{
						id: 91,
						start_time: '18:00',
						home: { name: 'Canelo Alvarez', pt_name: 'Canelo Álvarez', odds: 1.5 },
						away: { name: 'Floyd Mayweather Jr.', pt_name: 'Floyd Mayweather Jr.', odds: 2.5 },
					},
					{
						id: 92,
						start_time: '18:00',
						home: { name: 'Manny Pacquiao', pt_name: 'Manny Pacquiao', odds: 1.7 },
						away: { name: 'Mike Tyson', pt_name: 'Mike Tyson', odds: 2.3 },
					},
					{
						id: 93,
						start_time: '18:00',
						home: { name: 'Muhammad Ali', pt_name: 'Muhammad Ali', odds: 1.6 },
						away: { name: 'Sugar Ray Leonard', pt_name: 'Sugar Ray Leonard', odds: 2.4 },
					},
				],
			},
			{
				league_name: 'WBA',
				pt_name: 'WBA',
				games: [
					{
						id: 94,
						start_time: '18:00',
						home: { name: 'Canelo Alvarez', pt_name: 'Canelo Álvarez', odds: 1.5 },
						away: { name: 'Floyd Mayweather Jr.', pt_name: 'Floyd Mayweather Jr.', odds: 2.5 },
					},
					{
						id: 95,
						start_time: '18:00',
						home: { name: 'Manny Pacquiao', pt_name: 'Manny Pacquiao', odds: 1.7 },
						away: { name: 'Mike Tyson', pt_name: 'Mike Tyson', odds: 2.3 },
					},
					{
						id: 96,
						start_time: '18:00',
						home: { name: 'Muhammad Ali', pt_name: 'Muhammad Ali', odds: 1.6 },
						away: { name: 'Sugar Ray Leonard', pt_name: 'Sugar Ray Leonard', odds: 2.4 },
					},
				],
			},
		],
	},
	{
		sport_id: 'darts',
		name: 'Darts',
		pt_name: 'Dardos',
		sport_icon: '/sports/icons/darts.svg',
		leagues: [
			{
				league_name: 'PDC',
				pt_name: 'PDC',
				games: [
					{
						id: 101,
						start_time: '18:00',
						home: { name: 'Michael van Gerwen', pt_name: 'Michael van Gerwen', odds: 1.6 },
						away: { name: 'Phil Taylor', pt_name: 'Phil Taylor', odds: 2.4 },
					},
					{
						id: 102,
						start_time: '18:00',
						home: { name: 'Peter Wright', pt_name: 'Peter Wright', odds: 1.8 },
						away: { name: 'Gary Anderson', pt_name: 'Gary Anderson', odds: 2.2 },
					},
					{
						id: 103,
						start_time: '18:00',
						home: { name: 'Gerwyn Price', pt_name: 'Gerwyn Price', odds: 1.7 },
						away: { name: 'Michael Smith', pt_name: 'Michael Smith', odds: 2.3 },
					},
				],
			},
			{
				league_name: 'BDO',
				pt_name: 'BDO',
				games: [
					{
						id: 104,
						start_time: '18:00',
						home: { name: 'Michael van Gerwen', pt_name: 'Michael van Gerwen', odds: 1.6 },
						away: { name: 'Phil Taylor', pt_name: 'Phil Taylor', odds: 2.4 },
					},
					{
						id: 105,
						start_time: '18:00',
						home: { name: 'Peter Wright', pt_name: 'Peter Wright', odds: 1.8 },
						away: { name: 'Gary Anderson', pt_name: 'Gary Anderson', odds: 2.2 },
					},
					{
						id: 106,
						start_time: '18:00',
						home: { name: 'Gerwyn Price', pt_name: 'Gerwyn Price', odds: 1.7 },
						away: { name: 'Michael Smith', pt_name: 'Michael Smith', odds: 2.3 },
					},
				],
			},
		],
	},
	{
		sport_id: 'golf',
		name: 'Golf',
		pt_name: 'Golfe',
		sport_icon: '/sports/icons/golf.svg',
		leagues: [
			{
				league_name: 'The Masters',
				pt_name: 'The Masters',
				games: [
					{
						id: 111,
						start_time: '18:00',
						home: { name: 'Tiger Woods', pt_name: 'Tiger Woods', odds: 1.5 },
						away: { name: 'Rory McIlroy', pt_name: 'Rory McIlroy', odds: 2.5 },
					},
					{
						id: 112,
						start_time: '18:00',
						home: { name: 'Jordan Spieth', pt_name: 'Jordan Spieth', odds: 1.7 },
						away: { name: 'Phil Mickelson', pt_name: 'Phil Mickelson', odds: 2.3 },
					},
					{
						id: 113,
						start_time: '18:00',
						home: { name: 'Dustin Johnson', pt_name: 'Dustin Johnson', odds: 1.6 },
						away: { name: 'Justin Thomas', pt_name: 'Justin Thomas', odds: 2.4 },
					},
				],
			},
			{
				league_name: 'PGA Championship',
				pt_name: 'Campeonato PGA',
				games: [
					{
						id: 114,
						start_time: '18:00',
						home: { name: 'Tiger Woods', pt_name: 'Tiger Woods', odds: 1.5 },
						away: { name: 'Rory McIlroy', pt_name: 'Rory McIlroy', odds: 2.5 },
					},
					{
						id: 115,
						start_time: '18:00',
						home: { name: 'Jordan Spieth', pt_name: 'Jordan Spieth', odds: 1.7 },
						away: { name: 'Phil Mickelson', pt_name: 'Phil Mickelson', odds: 2.3 },
					},
					{
						id: 116,
						start_time: '18:00',
						home: { name: 'Dustin Johnson', pt_name: 'Dustin Johnson', odds: 1.6 },
						away: { name: 'Justin Thomas', pt_name: 'Justin Thomas', odds: 2.4 },
					},
				],
			},
		],
	},
	{
		sport_id: 'ice-hockey',
		name: 'Hockey',
		pt_name: 'Hóquei no Gelo',
		sport_icon: '/sports/icons/ice-hockey.svg',
		leagues: [
			{
				league_name: 'NHL',
				pt_name: 'NHL',
				games: [
					{
						id: 121,
						start_time: '18:00',
						home: { name: 'Montreal Canadiens', pt_name: 'Montreal Canadiens', odds: 1.7 },
						away: { name: 'Toronto Maple Leafs', pt_name: 'Toronto Maple Leafs', odds: 2.3 },
					},
					{
						id: 122,
						start_time: '18:00',
						home: { name: 'New York Rangers', pt_name: 'New York Rangers', odds: 1.5 },
						away: { name: 'Boston Bruins', pt_name: 'Boston Bruins', odds: 2.5 },
					},
					{
						id: 123,
						start_time: '18:00',
						home: { name: 'Chicago Blackhawks', pt_name: 'Chicago Blackhawks', odds: 1.8 },
						away: { name: 'Detroit Red Wings', pt_name: 'Detroit Red Wings', odds: 2.2 },
					},
				],
			},
			{
				league_name: 'Stanley Cup',
				pt_name: 'Stanley Cup',
				games: [
					{
						id: 124,
						start_time: '18:00',
						home: { name: 'Montreal Canadiens', pt_name: 'Montreal Canadiens', odds: 1.7 },
						away: { name: 'Toronto Maple Leafs', pt_name: 'Toronto Maple Leafs', odds: 2.3 },
					},
					{
						id: 125,
						start_time: '18:00',
						home: { name: 'New York Rangers', pt_name: 'New York Rangers', odds: 1.5 },
						away: { name: 'Boston Bruins', pt_name: 'Boston Bruins', odds: 2.5 },
					},
					{
						id: 126,
						start_time: '18:00',
						home: { name: 'Chicago Blackhawks', pt_name: 'Chicago Blackhawks', odds: 1.8 },
						away: { name: 'Detroit Red Wings', pt_name: 'Detroit Red Wings', odds: 2.2 },
					},
				],
			},
		],
	},
	{
		sport_id: 'motor-sports',
		name: 'Motor sports',
		pt_name: 'Esportes a Motor',
		sport_icon: '/sports/icons/motor-sports.svg',
		leagues: [
			{
				league_name: 'Formula 1',
				pt_name: 'Fórmula 1',
				games: [
					{
						id: 131,
						start_time: '18:00',
						home: { name: 'Lewis Hamilton', pt_name: 'Lewis Hamilton', odds: 1.6 },
						away: { name: 'Max Verstappen', pt_name: 'Max Verstappen', odds: 2.4 },
					},
					{
						id: 132,
						start_time: '18:00',
						home: { name: 'Sebastian Vettel', pt_name: 'Sebastian Vettel', odds: 1.7 },
						away: { name: 'Fernando Alonso', pt_name: 'Fernando Alonso', odds: 2.3 },
					},
					{
						id: 133,
						start_time: '18:00',
						home: { name: 'Valtteri Bottas', pt_name: 'Valtteri Bottas', odds: 1.8 },
						away: { name: 'Charles Leclerc', pt_name: 'Charles Leclerc', odds: 2.2 },
					},
				],
			},
			{
				league_name: 'MotoGP',
				pt_name: 'MotoGP',
				games: [
					{
						id: 134,
						start_time: '18:00',
						home: { name: 'Valentino Rossi', pt_name: 'Valentino Rossi', odds: 1.8 },
						away: { name: 'Marc Marquez', pt_name: 'Marc Marquez', odds: 2.2 },
					},
					{
						id: 135,
						start_time: '18:00',
						home: { name: 'Jorge Lorenzo', pt_name: 'Jorge Lorenzo', odds: 1.7 },
						away: { name: 'Andrea Dovizioso', pt_name: 'Andrea Dovizioso', odds: 2.3 },
					},
					{
						id: 136,
						start_time: '18:00',
						home: { name: 'Maverick Vinales', pt_name: 'Maverick Vinales', odds: 1.6 },
						away: { name: 'Fabio Quartararo', pt_name: 'Fabio Quartararo', odds: 2.4 },
					},
				],
			},
		],
	},
]
